import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Plus, ShoppingBag } from 'lucide-react';
/**
 * Inline action dock — Create Booking + Quick Sale.
 * Rendered under the Active Sessions hero so primary creates live next to
 * the live-session signal rather than floating over content.
 */
export function MCActionDock({ onCreateBooking, onQuickSale, hidden }) {
    if (hidden)
        return null;
    return (_jsxs("div", { className: "mc-action-dock", children: [_jsxs("button", { type: "button", className: "mc-action-btn mc-action-btn-primary", onClick: onCreateBooking, children: [_jsx(Plus, { className: "h-4 w-4" }), _jsx("span", { children: "Create Booking" })] }), _jsxs("button", { type: "button", className: "mc-action-btn", onClick: onQuickSale, children: [_jsx(ShoppingBag, { className: "h-4 w-4" }), _jsx("span", { children: "Quick Sale" })] })] }));
}
